module.exports = __webpack_public_path__ + "img/new-icon.7dba356d.png";